import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IAccountGroupRequest, IAccountGroupResponse } from '../models/account-group.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class AccountGroupApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/AccountGroups`;
  }

  constructor(private http: HttpClient) {}

  loadAccountGroups(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IAccountGroupResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IAccountGroupResponse[]>>(this.url, { params });
  }

  loadAllAccountGroups(): Observable<IAccountGroupResponse[]> {
    const url = `${this.url}/List`;
    return this.http.get<IAccountGroupResponse[]>(url);
  }

  loadAccountGroupById(id: string): Observable<IAccountGroupResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IAccountGroupResponse>(url);
  }

  createAccountGroup(accountGroup: IAccountGroupRequest): Observable<IAccountGroupResponse> {
    return this.http.post<IAccountGroupResponse>(this.url, accountGroup, { headers });
  }

  updateAccountGroup(accountGroup: IAccountGroupRequest): Observable<IAccountGroupResponse> {
    const url = `${this.url}/${accountGroup.id}`;
    return this.http.put<IAccountGroupResponse>(url, accountGroup, { headers });
  }

  deleteAccountGroup(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
